import ptBrTranslations from "./pt-BR.json";
import enUsTranslations from "./en-US.json";

export const resources = {
  "pt-BR": { translation: ptBrTranslations },
  "en-US": { translation: enUsTranslations },
};
